module.exports = __webpack_public_path__ + "static/media/AeroCapture.32ce9939.svg";